import { React, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Video.css";
import axios from "axios";

import { VideoContext } from "../Helper/Context";
import { EachVideoTile } from "./Dashboard";
import { Button } from "antd";
import { LikeOutlined, DislikeOutlined } from "@ant-design/icons";
import config from '../config.json'

// function which shows the date between two dates
const days = function (date1, date2) {
  let dt1 = new Date(date1);
  let dt2 = new Date(date2);
  return Math.floor(
    (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
      Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
      (1000 * 60 * 60 * 24)
  );
};

// Render a YouTube video player

const EachVideo = () => {

  
    let {id} = useParams();
  const [data, setData] = useState([]);
  const [votes , setVotes] = useState([])

  const onClickHandler = async (value) => {
  
    try {
     await axios.patch(
        `${config.endpoint}v1/videos/${id}/votes`,
        {
          vote: { value },
          change: "increase",
        }
      );
    } catch (err) {
      console.log(err);
     
    }

    // const res = await getData(id)


    // if (res !== null) {
    //   setData(res.data);
    //   setVotes(res.data.votes)
    // }
  }; 
   const getData = async (id) => {
    const res = await await axios
      .get(
        `${config.endpoint}/videos/${id}`
      )
      .then((res) => res)
      .catch((err) => null);

    if (res != null) {
      setData(res.data);
      setVotes(res.data.votes)
    }
  };
 


  useEffect(() => {
    
    getData(id);


  }, []);



  //  Modify Url to work in Iframe.
  const url = `https://${data.videoLink}`;

  console.log(data);

  return (
    <div className="iframe-parent ">
      <iframe
        title="video"
        controls
        src={url}
        allowFullScreen
        frameBorder="0"
      />
      <div className="video-info">
        <div className="semi-bold show-max-two-lines">{data.title}</div>
        <div className="video-preview-metadata-container">
          <span>
            {data.viewCount} •{" "}
            {`${days(new Date(), data.releaseDate)} Days ago`}
          </span>
          <span>
            <Button type="primary" onClick={() => onClickHandler("upVote")}>
              <LikeOutlined /> {votes.upVotes}
            </Button>
            <Button type="primary" onClick={() => onClickHandler("downVote")}>
  <DislikeOutlined /> {votes.downVotes}{" "}
            </Button>
          </span>
        </div>
      </div>
    </div>
  );
};

const VideoPage = () => {
  const myVideos = useContext(VideoContext);
  const { id } = useParams();
  useEffect(() => {
    const filtered = myVideos.video.filter((value) => value._id !== id);
    myVideos.setVideo(filtered);
  }, []);

  return (
    <div className="grid-container">
      <EachVideo />
      <div
        style={{
          borderTop: "2px solid #fff ",
          marginLeft: 20,
          marginRight: 20,
        }}
      ></div>

      <div className="grid">
        {myVideos.video.slice(0, 10).map((val, idx) => {
          return (
            <EachVideoTile
              key={idx}
              className="item"
              imgLink={val.previewImage}
              time={val.releaseDate}
              videoId={val._id}
              title={val.title}
              viewCount={val.viewCount}
            />
          );
        })}
      </div>
    </div>
  );
};
export default VideoPage;
